/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlobalFilterExclusionInput } from './GlobalFilterExclusionInput';
import {
    GlobalFilterExclusionInputFromJSON,
    GlobalFilterExclusionInputFromJSONTyped,
    GlobalFilterExclusionInputToJSON,
    GlobalFilterExclusionInputToJSONTyped,
} from './GlobalFilterExclusionInput';
import type { LadderChallengeRules } from './LadderChallengeRules';
import {
    LadderChallengeRulesFromJSON,
    LadderChallengeRulesFromJSONTyped,
    LadderChallengeRulesToJSON,
    LadderChallengeRulesToJSONTyped,
} from './LadderChallengeRules';
import type { RankingSystem } from './RankingSystem';
import {
    RankingSystemFromJSON,
    RankingSystemFromJSONTyped,
    RankingSystemToJSON,
    RankingSystemToJSONTyped,
} from './RankingSystem';
import type { CompetitionFaq } from './CompetitionFaq';
import {
    CompetitionFaqFromJSON,
    CompetitionFaqFromJSONTyped,
    CompetitionFaqToJSON,
    CompetitionFaqToJSONTyped,
} from './CompetitionFaq';
import type { LadderStatus } from './LadderStatus';
import {
    LadderStatusFromJSON,
    LadderStatusFromJSONTyped,
    LadderStatusToJSON,
    LadderStatusToJSONTyped,
} from './LadderStatus';
import type { LadderRatingConfig } from './LadderRatingConfig';
import {
    LadderRatingConfigFromJSON,
    LadderRatingConfigFromJSONTyped,
    LadderRatingConfigToJSON,
    LadderRatingConfigToJSONTyped,
} from './LadderRatingConfig';
import type { MatchScoringMode } from './MatchScoringMode';
import {
    MatchScoringModeFromJSON,
    MatchScoringModeFromJSONTyped,
    MatchScoringModeToJSON,
    MatchScoringModeToJSONTyped,
} from './MatchScoringMode';
import type { LadderActivityRules } from './LadderActivityRules';
import {
    LadderActivityRulesFromJSON,
    LadderActivityRulesFromJSONTyped,
    LadderActivityRulesToJSON,
    LadderActivityRulesToJSONTyped,
} from './LadderActivityRules';
import type { MatchFormat } from './MatchFormat';
import {
    MatchFormatFromJSON,
    MatchFormatFromJSONTyped,
    MatchFormatToJSON,
    MatchFormatToJSONTyped,
} from './MatchFormat';

/**
 * 
 * @export
 * @interface UpdateLadderBody
 */
export interface UpdateLadderBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateLadderBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLadderBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLadderBody
     */
    gameId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLadderBody
     */
    matchModeId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLadderBody
     */
    ruleSetId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLadderBody
     */
    sponsorId?: string;
    /**
     * 
     * @type {RankingSystem}
     * @memberof UpdateLadderBody
     */
    rankingSystem?: RankingSystem;
    /**
     * 
     * @type {MatchScoringMode}
     * @memberof UpdateLadderBody
     */
    scoringMode?: MatchScoringMode;
    /**
     * 
     * @type {MatchFormat}
     * @memberof UpdateLadderBody
     */
    matchFormat?: MatchFormat;
    /**
     * 
     * @type {LadderRatingConfig}
     * @memberof UpdateLadderBody
     */
    ratingConfig?: LadderRatingConfig;
    /**
     * 
     * @type {LadderChallengeRules}
     * @memberof UpdateLadderBody
     */
    challengeRules?: LadderChallengeRules;
    /**
     * 
     * @type {LadderActivityRules}
     * @memberof UpdateLadderBody
     */
    activityRules?: LadderActivityRules;
    /**
     * 
     * @type {number}
     * @memberof UpdateLadderBody
     */
    teamSize?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLadderBody
     */
    maxParticipants?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLadderBody
     */
    requiresApproval?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLadderBody
     */
    isSeasonBased?: boolean;
    /**
     * Unix timestamp for season end
     * @type {number}
     * @memberof UpdateLadderBody
     */
    seasonEndDate?: number;
    /**
     * 
     * @type {LadderStatus}
     * @memberof UpdateLadderBody
     */
    status?: LadderStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateLadderBody
     */
    competitionId?: string;
    /**
     * ScoringTemplate ID for EVENT_PIPELINE scoring
     * @type {string}
     * @memberof UpdateLadderBody
     */
    scoringTemplateId?: string;
    /**
     * Entry fee amount in Fuel
     * @type {number}
     * @memberof UpdateLadderBody
     */
    entryFee?: number;
    /**
     * PayoutTable ID for distributing entry fees to top finishers
     * @type {string}
     * @memberof UpdateLadderBody
     */
    payoutTableId?: string;
    /**
     * Minimum participants required for prizes to pay out
     * @type {number}
     * @memberof UpdateLadderBody
     */
    minParticipants?: number;
    /**
     * 
     * @type {Array<CompetitionFaq>}
     * @memberof UpdateLadderBody
     */
    faqs?: Array<CompetitionFaq>;
    /**
     * Cheat-filtering match-bracketing gate — requires active Match Start / Round Start in Redis to score
     * @type {boolean}
     * @memberof UpdateLadderBody
     */
    requireActiveMatch?: boolean;
    /**
     * IDs of EventPipelineFilter documents to apply to this ladder's events. Layered on top of the game-wide global filter; blocks when any assigned filter votes BLOCK (conditions AND-compose within each filter; exclude conditions block on match, include conditions block on non-match).
     * @type {Array<string>}
     * @memberof UpdateLadderBody
     */
    appliedFilterIds?: Array<string>;
    /**
     * Break-glass exclusions of GLOBAL filters for this ladder (PRODUCT_PLAN D2(b)). excludedBy and excludedAt are stamped server-side and ignored if sent.
     * @type {Array<GlobalFilterExclusionInput>}
     * @memberof UpdateLadderBody
     */
    excludedGlobalFilters?: Array<GlobalFilterExclusionInput>;
    /**
     * Rule 4 opt-out. When true this ladder still scores events whose match context is missing. Default false — a ladder that declares what counts should not score events that cannot prove they qualify.
     * @type {boolean}
     * @memberof UpdateLadderBody
     */
    failOpenOnMissingContext?: boolean;
}



/**
 * Check if a given object implements the UpdateLadderBody interface.
 */
export function instanceOfUpdateLadderBody(value: object): value is UpdateLadderBody {
    return true;
}

export function UpdateLadderBodyFromJSON(json: any): UpdateLadderBody {
    return UpdateLadderBodyFromJSONTyped(json, false);
}

export function UpdateLadderBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLadderBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'matchModeId': json['matchModeId'] == null ? undefined : json['matchModeId'],
        'ruleSetId': json['ruleSetId'] == null ? undefined : json['ruleSetId'],
        'sponsorId': json['sponsorId'] == null ? undefined : json['sponsorId'],
        'rankingSystem': json['rankingSystem'] == null ? undefined : RankingSystemFromJSON(json['rankingSystem']),
        'scoringMode': json['scoringMode'] == null ? undefined : MatchScoringModeFromJSON(json['scoringMode']),
        'matchFormat': json['matchFormat'] == null ? undefined : MatchFormatFromJSON(json['matchFormat']),
        'ratingConfig': json['ratingConfig'] == null ? undefined : LadderRatingConfigFromJSON(json['ratingConfig']),
        'challengeRules': json['challengeRules'] == null ? undefined : LadderChallengeRulesFromJSON(json['challengeRules']),
        'activityRules': json['activityRules'] == null ? undefined : LadderActivityRulesFromJSON(json['activityRules']),
        'teamSize': json['teamSize'] == null ? undefined : json['teamSize'],
        'maxParticipants': json['maxParticipants'] == null ? undefined : json['maxParticipants'],
        'requiresApproval': json['requiresApproval'] == null ? undefined : json['requiresApproval'],
        'isSeasonBased': json['isSeasonBased'] == null ? undefined : json['isSeasonBased'],
        'seasonEndDate': json['seasonEndDate'] == null ? undefined : json['seasonEndDate'],
        'status': json['status'] == null ? undefined : LadderStatusFromJSON(json['status']),
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'scoringTemplateId': json['scoringTemplateId'] == null ? undefined : json['scoringTemplateId'],
        'entryFee': json['entryFee'] == null ? undefined : json['entryFee'],
        'payoutTableId': json['payoutTableId'] == null ? undefined : json['payoutTableId'],
        'minParticipants': json['minParticipants'] == null ? undefined : json['minParticipants'],
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(CompetitionFaqFromJSON)),
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
        'appliedFilterIds': json['appliedFilterIds'] == null ? undefined : json['appliedFilterIds'],
        'excludedGlobalFilters': json['excludedGlobalFilters'] == null ? undefined : ((json['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionInputFromJSON)),
        'failOpenOnMissingContext': json['failOpenOnMissingContext'] == null ? undefined : json['failOpenOnMissingContext'],
    };
}

export function UpdateLadderBodyToJSON(json: any): UpdateLadderBody {
    return UpdateLadderBodyToJSONTyped(json, false);
}

export function UpdateLadderBodyToJSONTyped(value?: UpdateLadderBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'gameId': value['gameId'],
        'matchModeId': value['matchModeId'],
        'ruleSetId': value['ruleSetId'],
        'sponsorId': value['sponsorId'],
        'rankingSystem': RankingSystemToJSON(value['rankingSystem']),
        'scoringMode': MatchScoringModeToJSON(value['scoringMode']),
        'matchFormat': MatchFormatToJSON(value['matchFormat']),
        'ratingConfig': LadderRatingConfigToJSON(value['ratingConfig']),
        'challengeRules': LadderChallengeRulesToJSON(value['challengeRules']),
        'activityRules': LadderActivityRulesToJSON(value['activityRules']),
        'teamSize': value['teamSize'],
        'maxParticipants': value['maxParticipants'],
        'requiresApproval': value['requiresApproval'],
        'isSeasonBased': value['isSeasonBased'],
        'seasonEndDate': value['seasonEndDate'],
        'status': LadderStatusToJSON(value['status']),
        'competitionId': value['competitionId'],
        'scoringTemplateId': value['scoringTemplateId'],
        'entryFee': value['entryFee'],
        'payoutTableId': value['payoutTableId'],
        'minParticipants': value['minParticipants'],
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(CompetitionFaqToJSON)),
        'requireActiveMatch': value['requireActiveMatch'],
        'appliedFilterIds': value['appliedFilterIds'],
        'excludedGlobalFilters': value['excludedGlobalFilters'] == null ? undefined : ((value['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionInputToJSON)),
        'failOpenOnMissingContext': value['failOpenOnMissingContext'],
    };
}

